<template>
  <div class="home">
    <booking />
  </div>
</template>

<script setup lang="ts">
import Booking from "@/features/booking/Booking.vue";
</script>
